(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-countdown"]) return;
  try {
    
  if (!customElements.get('product-countdown')) {
    class ProductCountdown extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.duration = Number(this.dataset.durationSeconds) * 1000;
        this.storageKey = this.dataset.storageKey;
        this.values = {
          days: this.querySelector('[data-countdown-days]'),
          hours: this.querySelector('[data-countdown-hours]'),
          minutes: this.querySelector('[data-countdown-minutes]'),
          seconds: this.querySelector('[data-countdown-seconds]'),
        };

        const now = Date.now();
        const storedDeadline = this.readDeadline();
        this.deadline = storedDeadline > now ? storedDeadline : now + this.duration;

        if (storedDeadline <= now) this.saveDeadline(this.deadline);

        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
      }

      readDeadline() {
        try {
          return Number(window.localStorage.getItem(this.storageKey)) || 0;
        } catch {
          return 0;
        }
      }

      saveDeadline(deadline) {
        try {
          window.localStorage.setItem(this.storageKey, String(deadline));
        } catch {
          return;
        }
      }

      clearDeadline() {
        try {
          window.localStorage.removeItem(this.storageKey);
        } catch {
          return;
        }
      }

      update() {
        const remainingSeconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const days = Math.floor(remainingSeconds / 86400);
        const hours = Math.floor((remainingSeconds % 86400) / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;

        this.values.days.textContent = String(days).padStart(2, '0');
        this.values.hours.textContent = String(hours).padStart(2, '0');
        this.values.minutes.textContent = String(minutes).padStart(2, '0');
        this.values.seconds.textContent = String(seconds).padStart(2, '0');

        if (remainingSeconds === 0) {
          window.clearInterval(this.interval);
          this.clearDeadline();
        }
      }
    }

    customElements.define('product-countdown', ProductCountdown);
  }

  } catch(e) { console.error(e); }
})();
})();
